import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContextHolder } from '@frontegg/angular';

@Injectable({
  providedIn: 'root'
})
export class SignOutService {
  private signOutSubject = new BehaviorSubject<boolean>(false);
  signOut$ = this.signOutSubject.asObservable();
  public isFilingContent: boolean = false;
  private signOutChannel = new BroadcastChannel('capture-sign-out');

  constructor() {
    this.signOutChannel.onmessage = () => (window.location.href = this.signedOutUrl);
  }

  private get signedOutUrl(): string {
    return `${window.location.origin}/signedout`;
  }

  /**
   * Sets the sign-out state.
   * @param state - The new sign-out state to set.
   */
  setSignOutState(state: boolean): void {
    this.signOutSubject.next(state);
  }

  /**
   * Gets the current sign-out state.
   */
  getSignOutState(): boolean {
    return this.signOutSubject.value;
  }

  /**
   * Signs out the user by redirecting to the logout URL.
   */
  signOut(): void {
    this.signOutChannel.postMessage('signOut');
    const baseUrl = ContextHolder.getContext().baseUrl;
    window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${this.signedOutUrl}`;
  }
}
